// Copyright © 2026 Qcells. All rights reserved.
//
// This software is proprietary and confidential. Unauthorized use,
// duplication, or distribution of software is strictly prohibited.

import React from 'react';
import { Tile } from '@carbon/react';
import type { ChecklistRollup } from '../../../types';

/** The four coverage counters above the checklist, per the design mock:
 * "5 Required open · 12 Satisfied · 3 Needs review · 2 Bypassed". */
export default function ChecklistStatTiles({ rollup }: { rollup: ChecklistRollup }) {
  const tiles = [
    { value: rollup.required_open, label: 'Required open' },
    { value: rollup.satisfied, label: 'Satisfied' },
    { value: rollup.needs_review, label: 'Needs review' },
    { value: rollup.bypassed, label: 'Bypassed' },
  ];
  return (
    <div className="obw-stat-tiles">
      {tiles.map(tile => (
        <Tile key={tile.label} className="obw-stat-tile">
          <span className="obw-stat-value">{tile.value}</span>
          <span className="obw-stat-label">{tile.label}</span>
        </Tile>
      ))}
    </div>
  );
}
